import React from 'react';
import pt from 'prop-types';

import { writeToClipboard } from 'utils/clipboard';

import Icon from 'components/icon';
import Popover from 'components/popover';

import './command.scss';

export default class Command extends React.PureComponent {
  static contextTypes = {
    notifySuccess: pt.func.isRequired,
  };

  static propTypes = {
    command: pt.string.isRequired,
  };

  onClickCopy = (event) => {
    event.preventDefault();

    const { notifySuccess } = this.context;
    const { command } = this.props;

    writeToClipboard(command).then(() =>
      notifySuccess('Command copied to clipboard'),
    );
  };

  render() {
    const { command } = this.props;

    return (
      <div className="command-container">
        <span className="command-sign">$</span>

        <Popover
          openOnHover
          message="Click to copy"
          align="center"
          triggerClassName="command-text"
          triggerChildren={command}
          triggerOnClick={this.onClickCopy}
        />

        <button
          className="command-copy"
          onClick={this.onClickCopy}
          type="button"
        >
          <Icon
            fa="clone"
            faType="regular"
            faSize="lg"
            className="fa-flip-vertical"
          />
        </button>
      </div>
    );
  }
}
